
export const graphOptions = [
    // {
    //     label: 'Lane Management KPI',
    //     value: 'lane_management_kpi'
    // },
    // {
    //     label: 'Vehicle Motion KPI',
    //     value: 'longitudinal_motion_kpi'
    // },
    // {
    //     label: 'Safe Driving KPI',
    //     value: 'safe_driving_kpi'
    // },
    // {
    //     label: 'Velocity KPI',
    //     value: 'ego_velocity'
    // },
    {
        label: 'L1 Lateral Acceleration KPI',
        value: 'l1_lateral_acceleration_kpi'
    },
    {
        label: 'L1 Lateral Jerk KPI',
        value: 'l1_lateral_jerk_kpi'
    },
    {
        label: 'L1 Longitudinal Deceleration KPI',
        value: 'l1_longitudinal_deceleration_kpi'
    },
    {
        label: 'L1 Longitudinal Acceleration KPI',
        value: 'l1_longitudinal_acceleration_kpi'
    },
    {
        label: 'L1 Longitudinal Jerk KPI',
        value: 'l1_longitudinal_jerk_kpi'
    },
    {
        label: 'L1 Longitudinal Velocity Drop KPI',
        value: 'l1_longitudinal_velocity_drop_kpi'
    },
    {
        label: 'L0 Collision Check KPI',
        value: 'l0_collision_check_kpi'
    },
    {
        label: 'L0 Lateral Safe Distance KPI',
        value: 'l0_lateral_safe_distance_kpi'
    },
    {
        label: 'L0 Longitudinal Safe Distance KPI',
        value: 'l0_longitudinal_safe_distance_kpi'
    },
    {
        label: 'L0 Offroad Check KPI',
        value: 'l0_offroad_check_kpi'
    },
    {
        label: 'L0 Lane Marking Check KPI',
        value: 'l0_lane_marking_check_kpi'
    },
    {
        label: 'L0 Indicator Check KPI',
        value: 'l0_indicator_checking_kpi'
    },
    {
        label: 'L0 Speed Limit Check KPI',
        value: 'l0_speed_limit_check_kpi'
    },
    {
        label: 'L0 False Indicator Check KPI',
        value: 'l0_false_indicator_check_kpi'
    },
    {
        label: 'RSS Longitudinal Safe Check KPI',
        value: 'rss_longitudinal_safe_check_kpi'
    },
    {
        label: 'RSS Lateral Left Safe Check KPI',
        value: 'rss_lateral_left_safe_check_kpi'
    },
    {
        label: 'RSS Lateral Right Safe Check KPI',
        value: 'rss_lateral_right_safe_check_kpi'
    }
]